import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import ServiceIcon from '../components/ServiceIcon';
import useSEO from '../hooks/useSEO';
import useJsonLd from '../hooks/useJsonLd';
import { PAGE_SEO, SITE_CONFIG } from '../data/seoConfig';
import { SERVICES } from '../mock';

export default function ServicesList() {
  useSEO(PAGE_SEO.services);

  useJsonLd('services-breadcrumb', {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_CONFIG.url },
      { '@type': 'ListItem', position: 2, name: 'Services', item: `${SITE_CONFIG.url}/services` },
    ],
  });

  useJsonLd('services-item-list', {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Ransen Digital Marketing Services',
    numberOfItems: SERVICES.length,
    itemListElement: SERVICES.map((s, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      url: `${SITE_CONFIG.url}/services/${s.slug}`,
      name: s.title,
    })),
  });

  return (
    <div>
      <PageHeader
        eyebrow='Services'
        title={<><span className='text-white'>Digital marketing services for</span> <span className='text-brand-gradient'>modern growth teams</span></>}
        description='Full-service digital marketing agency: paid media, SEO, LLMO, AEO, web design, social, video, and AI automation — delivered by senior operators.'
        crumbs={[{ label: 'Services' }]}
      />
      <section className='py-20'>
        <div className='max-w-7xl mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-5'>
          {SERVICES.map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`} className='glass-card rounded-2xl p-6 group'>
              <div className='flex items-start justify-between'>
                <div className='w-12 h-12 rounded-xl bg-gradient-to-br from-violet-500/20 to-fuchsia-500/10 border border-violet-500/25 flex items-center justify-center text-violet-200'>
                  <ServiceIcon name={s.icon} className='w-5 h-5'/>
                </div>
                <ArrowUpRight className='w-5 h-5 text-white/30 group-hover:text-violet-300 transition-colors'/>
              </div>
              <h3 className='mt-5 font-heading text-[19px] font-semibold text-white'>{s.title}</h3>
              <p className='mt-2 text-[14px] text-white/60 leading-relaxed'>{s.short}</p>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
